import ValueFactory from '../../util/ValueFactory';
import { CaseSettings } from '../../domain/case/CaseDomains';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { ActionJsonModel } from '../../domain/collection/rule/action/ActionDomains';
import { TransactionJsonModel } from '../../domain/stream/transaction/TransactionDomains';
import { ConfigurationActions } from '../actions/ConfigurationActions';

export interface ConfigurationState {
  configuration: CaseSettings;
  actions: ActionJsonModel[];
  eventItems: TransactionJsonModel[];
  lists: string[];
  isUpdate: boolean;
  isDirty: boolean;
}

const initialState: ConfigurationState = {
  configuration: ValueFactory.initializeDomainConfiguration(),
  actions: [],
  eventItems: [],
  lists: [],
  isUpdate: false,
  isDirty: false,
};

export const configurationReducer = (state: ConfigurationState = initialState, action: ReduxBaseAction<any, ConfigurationActions>) => {
  switch (action.type) {
    case 'CHANGE_CONFIGURATION':
      return { ...state, configuration: action.payload, isDirty: true };
    case 'CHANGE_CONFIGURATION_IS_UPDATE':
      return { ...state, isUpdate: action.payload };
    case 'CHANGE_ACTIONS':
      return { ...state, actions: action.payload };
    case 'CHANGE_EVENT_ITEMS':
      return { ...state, eventItems: action.payload };
    case 'CLEAR_CONFIGURATION':
      return { ...state, configuration: ValueFactory.initializeDomainConfiguration(), configurationSchema: undefined, isUpdate: false, isDirty: false };
    case 'CHANGE_LISTS':
      return { ...state, lists: action.payload };
    case 'CHANGE_CONFIGURATION_DIRTY':
      return { ...state, isDirty: action.payload };
    default:
      return state;
  }
};
